<div #messageModal class="message-modal">
  <p>{{ message }}</p>
  <div>
    <button class="button button--default" (click)="closeModal()">OK</button>
  </div>
</div>
